import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { requestEmailVerification } from '../../../../actions/accountActions';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IAccountReducer from '../../../../interfaces/reducers/accountReducer';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import { A, P } from '../../../base/typography';
import { RawLoader } from '../../../loading/loading';
import * as StyledModals from '../myShipmentsModals.styles';

interface Props {}

const VerifyEmail: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile } = userProfileReducer;

	const accountReducer: IAccountReducer = useSelector<IStore, IAccountReducer>(store => store.accountReducer);
	const { modalSubmitError, modalSubmitErrorDetails } = accountReducer;

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	useEffect(() => {
		if (userProfile?.email) {
			dispatch(requestEmailVerification(userProfile.email));
		}
	}, [dispatch, userProfile?.email]);

	if (!userProfile) return <RawLoader />;

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.verifyEmail')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}
			<P>{t('page-settings.verifyEmailMessage')}</P>
			<Button
				primary
				onClick={() => {
					closeModal();
				}}>
				{t('page-settings.close')}
			</Button>
		</StyledModals.Wrapper>
	);
};

export default VerifyEmail;
